/* ==========================================================================
   新品到货提醒（NEW ARRIVAL ALERT）—— M921-04（2026-09-21）
   ==========================================================================
   骨架 snippets/amada-new-arrival-alert.liquid，外壳原语 assets/amada-modal.js，
   样式 assets/amada-new-arrival-alert.css。

   提交（2026-10-05 第三版）：交给 Shopify 原生提交（验证码全由 Shopify 处理），页面刷新一次；
     回跳后 layout/theme.liquid 派发 amada:naa-posted，本脚本重新打开弹窗显示成功。
     前两版「脚本接管 submit 改 fetch」与 Shopify hCaptcha 流程冲突（卡死 / Invalid CAPTCHA token），已废弃。

   🚨 PENDING_KEY 与记录字段**必须**与 assets/amada-back-in-stock.js:18 和
      layout/theme.liquid 的内联脚本完全一致，否则回跳提示条认不出来。
      记录里**不存邮箱**（PII 不进 sessionStorage）；title/body 直接带上本弹窗
      自己的成功文案，所以提示条显示的是「新品到货」的话术而不是补货话术。
   ========================================================================== */
(function () {
  'use strict';

  /* 与 amada-back-in-stock.js / layout/theme.liquid 共用同一把钥匙，不要改名。 */
  var PENDING_KEY = 'amada:restock:pending';

  /* 兜底文案：后台没配、snippet 没传时才用得上（铁律：代码只放兜底）。 */
  var FALLBACK = {
    bodyPrefix: 'New arrival alert request',
    submit: 'sign up',
    submitting: 'submitting...',
    successTitle: 'Thanks. Your request has been received.',
    successBody: 'We will email you as soon as this item is available.',
    error: "We couldn't submit your request. Please try again.",
    challenge: 'Shopify could not verify this request. Please refresh the page and try again.',
    note: 'We will let you know as soon as this item is Available.'
  };

  function copyFor(form) {
    var node = form ? form.querySelector('[data-amada-naa-copy]') : null;
    function read(name, fallback) {
      var value = node ? node.getAttribute('data-' + name) : '';
      return value || fallback;
    }
    return {
      bodyPrefix: read('body-prefix', FALLBACK.bodyPrefix),
      submit: read('submit-label', FALLBACK.submit),
      submitting: read('submitting-label', FALLBACK.submitting),
      successTitle: read('success-title', FALLBACK.successTitle),
      successBody: read('success-body', FALLBACK.successBody),
      error: read('error', FALLBACK.error),
      challenge: read('challenge', FALLBACK.challenge),
      note: read('note', FALLBACK.note)
    };
  }

  /* ── sessionStorage 待确认记录 ─────────────────────────────────────── */

  function writePending(form, series) {
    var copy = copyFor(form);
    try {
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify({
        v: 1,
        formId: form.id || '',
        /* 没有商品，用「系列名」占这两个位：字段结构保持一致，
           theme.liquid 只读 title/body/ts，这两个字段纯属排查时的线索。 */
        productTitle: series || '',
        productHandle: '',
        title: copy.successTitle,
        body: copy.successBody,
        path: window.location.pathname,
        scroll: { x: window.scrollX || window.pageXOffset || 0, y: window.scrollY || window.pageYOffset || 0 },
        ts: Date.now()
      }));
    } catch (error) {
      /* 隐私模式/禁用存储：原生提交照常完成，只是回跳后没有提示，不影响报名本身。 */
    }
  }

  function clearPending() {
    try {
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {
      /* 同上：读写不可用时静默。 */
    }
  }


  /* ── 弹窗内的反馈行 ────────────────────────────────────────────────── */

  function feedbackNode(form) {
    var node = form.querySelector('.amada-naa-form__feedback, .amada-naa-form__note');
    if (!node) {
      node = document.createElement('p');
      form.appendChild(node);
    }
    return node;
  }

  function setFeedback(form, state, message) {
    var node = feedbackNode(form);
    node.className = 'amada-naa-form__feedback amada-naa-form__feedback--' + state;
    node.setAttribute('role', state === 'error' ? 'alert' : 'status');
    node.setAttribute('data-amada-naa-state', state);
    /* 服务端那次的标记要抹掉：留着的话 resetFeedback 会一直把它当「刚发生的错误」
       保住不清，用户改完邮箱再提交成功后还挂着上一轮的红字。 */
    node.removeAttribute('data-amada-naa-server-state');
    node.textContent = message;
  }

  /* 重开弹窗时把上一次的反馈恢复成说明文案，避免「上次的错误还挂在那」。 */
  function resetFeedback(form) {
    var node = form.querySelector('.amada-naa-form__feedback, .amada-naa-form__note');
    if (!node) return;
    if (node.hasAttribute('data-amada-naa-server-state')) return; /* 服务端刚给的错误，留着 */
    node.className = 'amada-naa-form__note';
    node.removeAttribute('role');
    node.removeAttribute('data-amada-naa-state');
    node.setAttribute('data-amada-naa-note', '');
    node.textContent = copyFor(form).note;
  }

  function setSubmitBusy(form, busy) {
    var copy = copyFor(form);
    var submit = form.querySelector('[data-amada-naa-submit]');
    var text = form.querySelector('[data-amada-naa-submit-text]');
    if (submit) submit.disabled = busy;
    if (text) text.textContent = busy ? copy.submitting : copy.submit;
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
    form.dataset.amadaNaaSubmitting = busy ? 'true' : 'false';
  }

  /* ── 打开 ──────────────────────────────────────────────────────────── */

  function modalRoot(id) {
    if (!id) return null;
    var list = document.querySelectorAll('[data-amada-modal]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-amada-modal') === id) return list[i];
    }
    return null;
  }

  function openAlert(id, series) {
    var root = modalRoot(id);
    if (!root) return;
    var form = root.querySelector('[data-amada-naa-form]');
    if (form) {
      resetFeedback(form);
      setSubmitBusy(form, false);
      form.dataset.amadaNaaSeries = series || '';
      var message = form.querySelector('[data-amada-naa-message]');
      if (message) {
        var prefix = copyFor(form).bodyPrefix;
        message.value = series ? (prefix + ' — ' + series) : prefix;
      }
    }
    if (window.AmadaModal && typeof window.AmadaModal.open === 'function') {
      window.AmadaModal.open(id);
    }
    if (form) warmCaptcha(form);
  }

  /**
   * 触发器走**冒泡**阶段的 document 委托即可：
   * amada-modal.js 的捕获监听只在命中 `[data-amada-modal-open]` 时才
   * stopImmediatePropagation，而这里的按钮**故意不带**那个属性
   * （带了就会被它先接管，拿不到是哪个系列，也就没法把系列名写进邮件正文）。
   */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var trigger = target.closest('[data-amada-naa-open]');
    if (!trigger) return;
    event.preventDefault();
    openAlert(
      trigger.getAttribute('data-amada-naa-open'),
      trigger.getAttribute('data-amada-naa-series') || ''
    );
  });

  /* ── 提交 ──────────────────────────────────────────────────────────── */

  /* ── 提交：交给 Shopify 原生（2026-10-05 第三版，用户拍板「先止血」）──────────────
     店铺开了 Shopify hCaptcha。读过它的源码（storefront-forms-hcaptcha v1.5.3）：绑定表单时
     会用自己的函数替换 form.submit，每次提交先 execute 拿一次性 token，再调「绑定时的 submit」
     原生发出去。前两版用脚本接管 submit 改 fetch，和它的流程打架：有时等不到回调（卡在
     SUBMITTING），兜底强行原生提交又带着无效 token（Shopify 报错页 "Invalid CAPTCHA token"）。
     现在完全不接管：提交与验证码全部由 Shopify 处理，页面会刷新一次；回跳后
     layout/theme.liquid 的内联脚本派发 amada:naa-posted，下方监听重新打开弹窗显示成功。
     这里只做三件事：
       ① 打一条待确认记录（含滚动位置），回跳后据此判断「刚刚提交过」；
       ② 按钮显示提交中、防重复点击；RESET_MS 后若仍停在本页（如用户关掉了验证题）就恢复按钮，
          不报错、也不再强行提交；
       ③ 提交那一刻 hCaptcha 还没绑定好时，验证码脚本只拦截不提交 → 绑定后替用户补交一次。 */
  var RESET_MS = 15000;
  var BIND_WAIT_MS = 10000;
  var POLL_MS = 300;

  /** 弹窗一打开就预热验证码：Shopify 验证码脚本要等表单第一次 focusin 才去加载 hCaptcha，
      用户点 SIGN UP 的那一刻才加载的话，这次提交会被拦下（③ 会补交，但能提前绑好更稳）。 */
  function warmCaptcha(form) {
    try {
      var el = form.querySelector('input[type="email"]') || form;
      el.dispatchEvent(new window.FocusEvent('focusin', { bubbles: true }));
    } catch (e) {
      /* 预热失败只是退回「提交时再加载」，③ 兜得住 */
    }
  }

  function submitForm(form, event) {
    if (form.dataset.amadaNaaSubmitting === 'true') {
      event.preventDefault();
      return;
    }
    var boundAtSubmit = !!form.dataset.hcaptchaBound;
    writePending(form, form.dataset.amadaNaaSeries || '');
    setSubmitBusy(form, true);

    if (form._amadaNaaReset) window.clearTimeout(form._amadaNaaReset);
    form._amadaNaaReset = window.setTimeout(function () {
      form._amadaNaaReset = null;
      setSubmitBusy(form, false);
    }, RESET_MS);

    /* 本轮事件派发完再看：被验证码脚本拦下、且提交时还没绑定 → 等绑定后补交一次 */
    window.setTimeout(function () {
      if (!event.defaultPrevented || boundAtSubmit || typeof form.requestSubmit !== 'function') return;
      var waited = 0;
      var timer = window.setInterval(function () {
        waited += POLL_MS;
        if (form.dataset.hcaptchaBound) {
          window.clearInterval(timer);
          form.requestSubmit();
        } else if (waited >= BIND_WAIT_MS) {
          window.clearInterval(timer);
        }
      }, POLL_MS);
    }, 0);
  }

  /* ── 回跳：重新打开弹窗显示成功（由 layout/theme.liquid 的内联脚本派发）── */
  document.addEventListener('amada:naa-posted', function (event) {
    var detail = event.detail || {};
    var form = detail.formId ? document.getElementById(detail.formId) : null;
    if (!form || typeof form.matches !== 'function' || !form.matches('[data-amada-naa-form]')) return;
    var host = form.closest('[data-amada-modal]');
    if (!host || !window.AmadaModal || typeof window.AmadaModal.open !== 'function') return;
    var copy = copyFor(form);
    window.AmadaModal.open(host.getAttribute('data-amada-modal'));
    setFeedback(form, 'success', (detail.title || copy.successTitle) + ' ' + (detail.body || copy.successBody));
    detail.handled = true;
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('[data-amada-naa-form]')) return;
    submitForm(form, event);
  });

  /* ── 服务端错误回显：原生提交失败时把弹窗自动打开 ──────────────────── */

  function showServerErrors() {
    var nodes = document.querySelectorAll('[data-amada-naa-server-state="error"]');
    for (var i = 0; i < nodes.length; i++) {
      var host = nodes[i].closest('[data-amada-modal]');
      if (!host) continue;
      /* 提交失败了，回跳提示条不该再弹一条成功。 */
      clearPending();
      if (window.AmadaModal && typeof window.AmadaModal.open === 'function') {
        window.AmadaModal.open(host.getAttribute('data-amada-modal'));
      }
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showServerErrors);
  } else {
    showServerErrors();
  }
})();
